import type { Activity, ActivityType } from 'types';

export const autoFactorKinds = ['WEEKLY', 'MONTHLY', 'LENGTH'] as const;
export type AutoFactorKind = (typeof autoFactorKinds)[number];

export type FactorApplicationPolicy = {
  readonly exclude_auto_kind: readonly AutoFactorKind[];
};

export type FactorPolicyDraft = {
  present: boolean;
  excludeAutoKind: AutoFactorKind[];
};

export const factorKindLabels: Record<AutoFactorKind, string> = {
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  LENGTH: 'Length',
};

export function applicableFactorPolicy(type: ActivityType, activity: Activity | null): boolean {
  return type === 'RADIO' && (activity === null || (activity.kind === 'MEDIA' && activity.non_standard === false));
}

export function copyFactorPolicy(policy: FactorApplicationPolicy | null): FactorApplicationPolicy | null {
  return policy === null ? null : { exclude_auto_kind: [...policy.exclude_auto_kind] };
}

export function policyToDraft(policy: FactorApplicationPolicy | null): FactorPolicyDraft {
  return {
    present: policy !== null,
    excludeAutoKind: policy ? [...policy.exclude_auto_kind] : [],
  };
}

export function draftToPolicy(draft: FactorPolicyDraft): FactorApplicationPolicy | null {
  if (!draft.present) return null;
  return {
    exclude_auto_kind: autoFactorKinds.filter((kind) => draft.excludeAutoKind.includes(kind)),
  };
}

export function policySummary(policy: FactorApplicationPolicy | null): string {
  if (policy === null) return 'Inherited';
  if (policy.exclude_auto_kind.length === 0) return 'No exclusions';
  return `Exclude ${policy.exclude_auto_kind.map((kind) => factorKindLabels[kind].toLowerCase()).join(', ')}`;
}
